<script lang="ts">
	export let title: AdjustMarginTitleType;
	import { activeSection } from '$lib/home/userInteract/store';
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import type { AdjustMarginTitleType } from './adjustMarginTypes';
	function setActiveSection() {
		$activeSection = title;
	}
</script>

{#if $activeSection == title}
	<GradientBorder
		gradient="bg-fx-gradient-20"
		paddingClass="p-px"
		borderRadius="rounded-3xl"
		outerClassList="cursor-pointer"
		innerClassList="flex justify-center items-center bg-fx-black"
	>
		<div class="bg-fx-gradient-6 rounded-3xl px-5 py-2 text-fx-grey-100 font-semibold">{title}</div>
	</GradientBorder>
{:else}
	<div
		class="text-fx-grey-400 font-semibold border border-fx-grey-500 py-2 px-5 rounded-3xl cursor-pointer"
		on:click={setActiveSection}
		on:keydown={setActiveSection}
	>
		{title}
	</div>
{/if}
